// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-link-wrapper[data-v-6e67e0ca]{position:sticky;top:96px}.details-wrapper label[data-v-6e67e0ca]{margin-right:4px}.rtl[data-v-6e67e0ca]{direction:rtl;text-align:right}", ""]);
// Exports
module.exports = exports;
